import {patchState, signalStore, withMethods, withState} from "@ngrx/signals";
import {Project} from "../types/project.type";
import {computed, inject, Signal, Type} from "@angular/core";
import {ProjectRecord} from "../types/project-record.type";
import {HttpClient} from "@angular/common/http";
import {sessionSave} from "./features/sessionSave.feature.store";
import {orderBy} from "../util/orderBy";

type projectStoreState = {
    id: string|null //id can be only instantiate from backend entity
    name: string|null,
    isPublic: boolean,
    projectRecord: ProjectRecordStoreState|null,
    saves: Array<ProjectSave>
}

type ProjectRecordStoreState = {
    id: string|null,
    name: string
}

type ProjectSave = {
    id: string,
    name: string,
    isPublic: boolean,
    projectRecord: ProjectRecordStoreState,
    createdAt: number
}

export type ProjectStore = InstanceType<typeof ProjectStore>;

export const ProjectStore = signalStore(

    { providedIn: "root" },

    withState<projectStoreState>({
        id: null,
        name: null,
        isPublic: false,
        projectRecord: null,
        saves: []
    }),
    withMethods((
        store,
        http = inject(HttpClient)
    )=>({

        setPublic: (isPublic: boolean) => {
            patchState(store, {isPublic})
        },

        nameProject: (name: string) => {
            patchState(store, {name})
        },

        getProject: (): Signal<Project> => {
          return computed(()=>({
                id: store.id(),
                name: store.name(),
                isPublic: store.isPublic()
          }))
        },

        setProject: (project: Partial<projectStoreState>) => {
            patchState(store, {...project})
        },

        clearProject: () => {
            patchState(store, {id: null, name: null, isPublic: false, projectRecord: null})
        },

        clearProjectRecord: () => {
            patchState(store, {projectRecord: null})
        },

        provideProjectRecord: ( name: string = 'Project Record - '+Date.now(), recordId?: string, projectId?: string ): ProjectRecord => {

            return {
                id: recordId,
                projectId: projectId,
                name: name,
                //lamellaAreaGroups: lamelAreaStore.getLamellaAreaGroups()
            }

        },

        provideProject(projectData?: Partial<Project>): Project{

            return {
                id: projectData?.id ?? store?.id(),
                name: projectData?.name ?? store?.name(),
                isPublic: projectData.isPublic ?? store?.isPublic()
            }

        },

        saveNewProject( project: Project ) {
            return new Promise((resolve) => http.post( '/api/project', project ).subscribe((project: any) =>{
                patchState(store, {
                    id: project.id,
                    name: project.name,
                    projectRecord: {
                        id: project.projectRecords[0].id,
                        name: project.projectRecords[0].name
                    }
                });
                this.addSave(project);
                resolve(project);
            }));
        },

        saveNewProjectRecord( projectRecord: any ){
            return new Promise((resolve, reject)=>http.post( `/api/project/${store.id()}`, projectRecord ).subscribe((project) => {
                this.addSave(project);
                resolve(project);
            }));
        },

        isSupported: (projectId: string, projectRecordId: string): Promise<boolean> => {
            return new Promise<boolean>( (resolve) => http.get<boolean>( `/api/project/${projectId}/${projectRecordId}/available` )
                .subscribe(resolve));
        },

        fetchProject(projectId: string, projectRecordId: string) {
            return new Promise<any>((resolve)=> http.get<any>( `/api/project/${projectId}/${projectRecordId}`)
                .subscribe((a)=>{
                    patchState(store, {
                        id: a.id,
                        name: a.name,
                        isPublic: a.isPublic,
                        projectRecord: {
                            id: a.projectRecords[0].id,
                            name: a.projectRecords[0].name
                        }
                    });

                    resolve(a)
                })
            );
        },

        setProjectInfo: (project: any) => {
            patchState(store, {
                id: project.id,
                name: project.name,
                isPublic: project.isPublic,
                projectRecord: {
                    id: (orderBy(project.projectRecords, 'createdAt', "desc")[0] as any).id,
                    name: (orderBy(project.projectRecords, 'createdAt', "desc")[0] as any).name
                }
            })
        },

        addSave(project: any){
            patchState(store, {
                saves: [
                    {
                        id: project.id,
                        name: project.name,
                        isPublic: project.isPublic,
                        projectRecord: {
                            id: (orderBy(project.projectRecords, 'createdAt', "desc")[0] as any).id,
                            name: (orderBy(project.projectRecords, 'createdAt', "desc")[0] as any).name
                        },
                        createdAt: Date.now()
                    },
                    ...store.saves(),
                ]
            })
        }

    })),

    sessionSave( 'projectId', ['saves'] )
)